import ChatContainer from "./ChatContainer";
export default ChatContainer;